export const common = {
  'site.name': 'CSSBuy Spreadsheet',
  'site.tagline': 'Encontre Produtos, Vendedores e Guias em um Só Lugar',
  'nav.home': 'Início',
  'nav.categories': 'Categorias',
  'nav.guides': 'Guias',
  'nav.shoppingGuide': 'Guia de Compras',
  'nav.qc': 'Centro de QC',
  'nav.shipping': 'Envio',
  'nav.reviews': 'Avaliações',
  'nav.safety': 'Segurança',
  'nav.about': 'Sobre',
  'nav.contact': 'Contato',
  'lang.pt': 'Português',
  'lang.de': 'Deutsch',
  'lang.en': 'English',
  'cta.explore': 'Explorar CSSBuy Spreadsheet',
  'cta.visitMain': 'Visitar Site Principal',
  'cta.buyNow': 'Comprar Agora',
  'cta.readMore': 'Ler Mais',
  'cta.viewAll': 'Ver Tudo',
  'cta.search': 'Pesquisar',
  'footer.disclaimer': 'Este site é um recurso informativo independente e não está necessariamente afiliado à CSSBuy.',
  'footer.copyright': '© 2026 CSSBuy Spreadsheet. Todos os direitos reservados.',
  'footer.links': 'Links',
  'footer.resources': 'Recursos',
  'footer.legal': 'Legal',
  'footer.privacy': 'Política de Privacidade',
  'footer.terms': 'Termos de Uso',
  'footer.editorial': 'Política Editorial',
  'footer.sitemap': 'Mapa do Site',
  'hero.title': 'CSSBuy Spreadsheet: Encontre Produtos, Vendedores e Guias em um Só Lugar',
  'hero.subtitle': 'Explore uma coleção organizada de CSSBuy spreadsheets, produtos, vendedores, categorias e guias práticos para pesquisar melhor, comparar opções e entender cada etapa da sua compra.',
  'hero.trust': 'Recursos organizados • Guias atualizados • Suporte multilíngue',
  'search.placeholder': 'Pesquise produtos, vendedores, categorias ou palavras-chave...',
  'search.popular': 'Populares:',
  'categories.title': 'Explore as Categorias Mais Populares',
  'categories.subtitle': 'Encontre recursos organizados por categoria para tornar sua pesquisa mais rápida e simples.',
  'categories.shoes': 'Tênis',
  'categories.hoodies': 'Moletom/Suéteres',
  'categories.tshirts': 'Camisetas',
  'categories.jackets': 'Jaquetas',
  'categories.pants': 'Calças/Shorts',
  'categories.headwear': 'Toucas/Chapéus',
  'categories.sets': 'Conjuntos',
  'categories.underwear': 'Roupas Íntimas',
  'categories.jersey': 'Camisas de Time',
  'categories.accessories': 'Acessórios',
  'categories.bags': 'Bolsas',
  'categories.belts': 'Cintos',
  'categories.perfumes': 'Perfumes',
  'categories.other': 'Outros',
  'spreadsheet.title': 'Por que usar um CSSBuy Spreadsheet?',
  'spreadsheet.desc': 'Um spreadsheet bem organizado pode ajudar você a encontrar produtos e vendedores com mais facilidade, comparar informações e reduzir o tempo gasto pesquisando diferentes fontes.',
  'spreadsheet.faster': 'Pesquisa mais rápida',
  'spreadsheet.fasterDesc': 'Encontre recursos por produto, categoria ou vendedor.',
  'spreadsheet.organized': 'Tudo organizado',
  'spreadsheet.organizedDesc': 'Consulte informações em uma estrutura simples e fácil de navegar.',
  'spreadsheet.context': 'Mais contexto',
  'spreadsheet.contextDesc': 'Combine spreadsheets com guias de QC, vendedores e envio.',
  'guides.title': 'Tudo o que você precisa antes de comprar',
  'guides.desc': 'Aprenda como pesquisar produtos, avaliar vendedores, analisar fotos de QC e considerar diferentes opções de envio.',
  'guides.howToUse': 'Como usar CSSBuy Spreadsheet',
  'guides.evaluateSellers': 'Como avaliar vendedores',
  'guides.qcPhotos': 'Como analisar fotos de QC',
  'guides.shipping': 'Como entender o envio',
  'safety.title': 'Segurança em primeiro lugar',
  'safety.desc': 'Sempre verifique links, fontes e informações antes de comprar. Nunca compartilhe sua senha ou dados pessoais com páginas desconhecidas. Tenha cuidado com ofertas, cupons e vendedores não verificados.',
  'commercial.title': 'Pesquisando CSSBuy? Comece pelas informações certas.',
  'commercial.review': 'Avaliação CSSBuy',
  'commercial.shipping': 'Custo de Envio CSSBuy',
  'commercial.coupon': 'Cupom CSSBuy',
  'commercial.discount': 'Código de Desconto CSSBuy',
  'commercial.warehouse': 'Armazém CSSBuy',
  'commercial.legit': 'CSSBuy é Confiável?',
  'finalCta.title': 'Pronto para começar sua pesquisa?',
  'finalCta.desc': 'Explore o CSSBuy Spreadsheet, encontre recursos relevantes e continue sua jornada de compra com informações mais organizadas.',
  'articles.title': 'Guias e Artigos Recentes',
  'articles.subtitle': 'Conteúdo original e aprofundado para ajudar você a tomar melhores decisões.',
  'article.cssbuyGuide.title': 'CSSBuy Spreadsheet: Guia Completo para Iniciantes',
  'article.cssbuyGuide.excerpt': 'Aprenda a usar CSSBuy spreadsheets para encontrar produtos, comparar vendedores e tomar decisões de compra informadas. Este guia abrangente cobre desde o básico até dicas avançadas.',
  'article.cssbuyGuide.readTime': '8 min de leitura',
  'article.cssbuyGuide.date': 'Agosto 2026',
  'breadcrumb.home': 'Início',
  'breadcrumb.articles': 'Artigos',
  'dropdown.allCategories': 'Todas as Categorias',
  'dropdown.shoes': 'Tênis',
  'dropdown.hoodies': 'Moletom/Suéteres',
  'dropdown.tshirts': 'Camisetas',
  'dropdown.jackets': 'Jaquetas',
  'dropdown.pants': 'Calças/Shorts',
  'dropdown.headwear': 'Toucas/Chapéus',
  'dropdown.sets': 'Conjuntos',
  'dropdown.underwear': 'Roupas Íntimas',
  'dropdown.jersey': 'Camisas de Time',
  'dropdown.accessories': 'Acessórios',
  'dropdown.bags': 'Bolsas',
  'dropdown.belts': 'Cintos',
  'dropdown.perfumes': 'Perfumes',
  'dropdown.other': 'Outros',
};

export default common;